export enum AppPermissionInheritance {
  None = 'NONE',
  InheritDescendants = 'INHERIT_DESCENDANTS',
  BlockThisEntityAndDescendants = 'BLOCK_THIS_ENTITY_AND_DESCENDANTS',
  BlockDescendants = 'BLOCK_DESCENDANTS',
}
